import scssVariables from '@styles/variables.module.scss';

import { ThemeColors } from './types';

export const colors: ThemeColors = {
  legacyWhite: scssVariables.ColorLegacyWhite,
  offWhite: scssVariables.ColorOffWhite,
  offWhiteLight: scssVariables.ColorOffWhiteLight,
  lightGray: scssVariables.ColorLightGray,
  gray: scssVariables.ColorGray,
  darkGray: scssVariables.ColorDarkGray,
  black: scssVariables.ColorBlack,
  pink: scssVariables.ColorPink,
  darkPink: scssVariables.ColorDarkPink,
  lightPink: scssVariables.ColorLightPink,
  softPink: scssVariables.ColorSoftPink,
  lavenderGray: scssVariables.ColorLavenderGrey,
  lightLavenderGray: scssVariables.ColorLightLavenderGrey,
  pink10: scssVariables.ColorPink10,
  pink20: scssVariables.ColorPink20,
  pink40: scssVariables.ColorPink40,
  pink60: scssVariables.ColorPink60,
  pink80: scssVariables.ColorPink80,
  pink100: scssVariables.ColorPink100,
  black00: scssVariables.ColorBlack00,
  black10: scssVariables.ColorBlack10,
  black20: scssVariables.ColorBlack20,
  black30: scssVariables.ColorBlack30,
  black40: scssVariables.ColorBlack40,
  black60: scssVariables.ColorBlack60,
  black80: scssVariables.ColorBlack80,
  black100: scssVariables.ColorBlack100,
  purple10: scssVariables.ColorPurple10,
  purple20: scssVariables.ColorPurple20,
  purple40: scssVariables.ColorPurple40,
  purple60: scssVariables.ColorPurple60,
  purple80: scssVariables.ColorPurple80,
  purple100: scssVariables.ColorPurple100,
  fog10: scssVariables.ColorFog10,
  fog20: scssVariables.ColorFog20,
  fog40: scssVariables.ColorFog40,
  fog60: scssVariables.ColorFog60,
  fog80: scssVariables.ColorFog80,
  fog100: scssVariables.ColorFog100,
  blue10: scssVariables.ColorBlue10,
  blue20: scssVariables.ColorBlue20,
  blue40: scssVariables.ColorBlue40,
  blue60: scssVariables.ColorBlue60,
  blue80: scssVariables.ColorBlue80,
  blue100: scssVariables.ColorBlue100,
  maroon10: scssVariables.ColorMaroon10,
  maroon20: scssVariables.ColorMaroon20,
  maroon40: scssVariables.ColorMaroon40,
  maroon60: scssVariables.ColorMaroon60,
  maroon80: scssVariables.ColorMaroon80,
  maroon100: scssVariables.ColorMaroon100,
  coral10: scssVariables.ColorCoral10,
  coral20: scssVariables.ColorCoral20,
  coral40: scssVariables.ColorCoral40,
  coral60: scssVariables.ColorCoral60,
  coral80: scssVariables.ColorCoral80,
  coral100: scssVariables.ColorCoral100,
  warning10: scssVariables.ColorWarning10,
  warning80: scssVariables.ColorWarning80,
  warning100: scssVariables.ColorWarning100,
  success10: scssVariables.ColorSuccess10,
  success80: scssVariables.ColorSuccess80,
  success100: scssVariables.ColorSuccess100,
  error10: scssVariables.ColorError10,
  error80: scssVariables.ColorError80,
  error100: scssVariables.ColorError100,
  info10: scssVariables.ColorInfo10,
  info80: scssVariables.ColorInfo80,
  info100: scssVariables.ColorInfo100,
};
